import { toast } from "react-toastify";
import CryptoJS from "crypto-js";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import axios from "axios";
import { useState } from "react";

const iphone = window.navigator.userAgent.includes("Mac");

export function Userlogin() {
  if (localStorage.getItem("ca1rt6_t") === null) {
    return false;
  } else {
    return true;
  }
}
export async function saveurl(url, name) {
  if (iphone) {
    return window.location.assign(url);
    // return shareIphonePostMsg({
    //   url: url,
    //   action: "downloadFileLiveUrl",
    // });
  }
  const blob = await (await fetch(url)).blob();
  await saveAs(blob, name);
}

export function Toast(isSuccess, succ_msg, err_msg) {
  if (isSuccess || isSuccess === "true") {
    toast.success(succ_msg);
  } else {
    toast.error(err_msg);
  }
}
export const urltobase64 = async (url) => {
  const data = await fetch(url);
  const blob = await data.blob();
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise((resolve, reject) => {
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
    reader.onerror = (error) => reject(error);
  });
};
export const shareIphonePostMsg = ({
  data = "", // base64 string and action type is sharebase64 and pass filename
  action = "",
  title = "",
  filename = "",
  url = "", // no need of file name
  phone_number = "", // for open dial pad on number click or redirect to app on url click and action is open_url_linking
  nextChunk, // true or false and action is chunk
}) => {
  /* 
  ACTION TYPE BELOW
   1.urlshare => page url or text share on all social media but not image or pdf url.
   2.open_url_linking => redirect or navigate url on app like open dial pad on number or whatsapp or external linking like facebook redirect.
  3. sharebase64 => share docs base64 on all social apps becoz without share can't download docs on ios in webview.
  4. chunk => passing bs64 via chunk
  5. downloadBs64Media => donwload media like image or video in specific folder
  */
  console.log("url", url);

  try {
    if (!window.ReactNativeWebView || !window.ReactNativeWebView.postMessage) {
      throw new Error("React Native WebView is not available.");
    }

    const message = JSON.stringify({
      filename,
      data,
      action,
      title,
      url,
      phone_number,
      nextChunk,
    });

    window.ReactNativeWebView.postMessage(message);
  } catch (error) {
    console.error("Error in shareIphonePostMsg:", error.message);
    Toast(
      false,
      "",
      error.message || "Error in React Native WebView postMessage."
    );
  }
};
export async function Shareurl(url, text, title) {
  // if (navigator.share) {
  //   try {
  //     await navigator.share({
  //       title: title,
  //       text: text,
  //       url: url,
  //     });
  //     console.log('Content shared successfully');
  //   } catch (error) {
  //     console.error('Error sharing content:', error);
  //   }
  // } else {
  //   // Fallback if navigator.share is not supported
  //   alert('Web Share API is not supported in your browser. Please copy the URL manually.');
  //   navigator.clipboard.writeText(url)
  //     .then(() => alert('URL copied to clipboard'))
  //     .catch((error) => console.error('Error copying URL to clipboard:', error));
  // }
  if (iphone) {
    return shareIphonePostMsg({ url, action: "urlshare" });
  }
  if (navigator.share) {
    try {
      await navigator.share({
        url: url,
        title: localStorage.getItem("Ca1nioamed") || "Carthi Dealer",
      });
      console.log("Share was successful.");
    } catch (error) {
      console.log("Sharing failed", error);
    }
  } else {
    alert("Your system doesn't support the Web Share APIs.");
  }
}
export async function ShareurlWithImg({ url, text, title, imgUrl, filename }) {
  if (iphone) {
    return shareIphonePostMsg({ url, action: "urlshare" });
  }
  // let blob;
  // let file;
  // let fileName;

  // if (imgUrl) {
  //   console.log("imgUrl", imgUrl);

  //   fileName = filename || imgUrl.split("/").pop();

  //   blob = await fetchBlobFromUrl({ url: imgUrl });
  //   file = new File([blob], fileName, { type: blob?.type });
  // }
  let shareLink = text ? url + "\n" + text : url;
  if (
    navigator.share &&
    navigator.canShare({
      text: shareLink,
    })
  ) {
    try {
      await navigator.share({
        // url: url + "\nhexa",
        // title: "Carthi Dealer",
        text: shareLink,
      });
      console.log("Share was successful.");
    } catch (error) {
      console.log("Sharing failed with image", error);
    }
  } else {
    alert("Your system doesn't support the Web Share APIs.");
  }
}

export async function getCarCompanies() {
  let res = [];
  await fetch(process.env.REACT_APP_API_ENDPOINT + "/api/Common/companydata")
    .then((response) => response.json())
    .then((res) => {
      res = res.Data;
    });
  return res;
}

export function OnLogout() {
  localStorage.clear();
  sessionStorage.clear();
  Toast("true", "Logout Successfully", "false");
  window.location.href = "/";
}
export function Phonepe(amount, orderid) {
  var payload = {
    merchantId: `PGTESTPAYUAT`,
    merchantTransactionId: orderid,
    merchantUserId: "MUIE2122",
    amount: parseInt(amount) * 100,
    redirectUrl: "https://localhost:3000",
    redirectMode: "POST",
    callbackUrl: "https://localhost:3000",
    mobileNumber: "9769111222",
    paymentInstrument: {
      type: "PAY_PAGE",
    },
  };
  const base64 = btoa(JSON.stringify(payload));
  const sign = base64 + `/pg/v1/pay099eb0cd-02cf-4e2a-8aca-3e6c6aff0399`; // Modify this accordingly based on your API
  var X_VERIFY = signRequest(sign) + "###1";
  console.log("X_VERIFY", X_VERIFY);

  const requestBody = {
    request: base64,
  };
  var PhonePeGatewayURL = "/apis/pg-sandbox/pg/v1/pay";
  const options = {
    method: "POST",
    headers: {
      accept: "application/json",
      "Content-Type": "application/json",
      "X-VERIFY": X_VERIFY,
    },
    body: JSON.stringify({
      request: base64,
    }),
  };

  fetch("https://api-preprod.phonepe.com/apis/pg-sandbox/pg/v1/pay", options)
    .then((response) => response.json())
    .then((response) => {
      window.location.assign(response.data.instrumentResponse.redirectInfo.url);
    })
    .catch((err) => console.error(err));
}

export async function GetDealerdata() {
  let Data = {};
  const header = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
    },
  };
  await fetch(
    process.env.REACT_APP_API_ENDPOINT + "/api/BrandingProfile/All",
    header
  )
    .then((response) => response.json())
    .then((res) => {
      if (res.Success === true) {
        Data = res.Data[0];
      }
    });
  return Data;
}

export function signRequest(payload) {
  // Assuming you are using CryptoJS for hashing
  const hashedPayload = CryptoJS.SHA256(payload).toString(CryptoJS.enc.Hex);
  console.log("hashstring" + hashedPayload);
  return hashedPayload;
}

export const ownerDrop = [
  { Value: 1, Text: 1 },
  { Value: 2, Text: 2 },
  { Value: 3, Text: 3 },
  { Value: 4, Text: 4 },
  { Value: 5, Text: 5 },
  { Value: 6, Text: 6 },
  { Value: 7, Text: 7 },
  { Value: 8, Text: 8 },
  { Value: 9, Text: 9 },
  { Value: 10, Text: 10 },
];

export const carstatus = [
  { Value: "Coming Soon", Text: "Coming Soon" },
  { Value: "In-Stock", Text: "In-Stock" },
];

export const DateFormate = (date) => {
  // console.log(date);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
  });
};

export const generatePDFWithTable = (dataArray) => {
  // use in leads
  // Create a new PDF document
  const pdf = new jsPDF();

  // Define the columns for the table
  const columns = [
    "No",
    "Date",
    "Name",
    "Contact No.",
    "Car Name",
    "Car No.",
    "Remarks",
  ];
  const title = localStorage.getItem("Ca1nioamed");
  // Define the rows for the table
  const rows = dataArray.map((item, index) => [
    index + 1,
    item.createdate,
    item.Name,
    item.Contactno,
    item.Modelyear + " " + item.carname + " " + item.variantname,
    item.Carno,
    item.nRemarks,
  ]);
  const pdfWidth = pdf.internal.pageSize.getWidth();
  pdf.text(title, pdfWidth / 2, 10, { align: "center" });
  // Add the table to the PDF document
  pdf.autoTable({
    head: [columns],
    body: rows,
  });
  let filename = "carleads" + new Date().toJSON().slice(0, 13) + ".pdf";
  if (iphone) {
    return shareIphonePostMsg({
      data: pdf.output("datauristring"),
      action: "sharebase64",
      filename,
    });
  }
  // Save the PDF with a filename
  pdf.save(filename);
};

export function base64ToBlob(base64) {
  const base64Data = base64.split(",")[1];
  const binaryString = atob(base64Data);
  const uint8Array = new Uint8Array(binaryString.length);
  for (let i = 0; i < binaryString.length; i++) {
    uint8Array[i] = binaryString.charCodeAt(i);
  }
  return new Blob([uint8Array], { type: "image/jpeg" });
}

// export async function fetchDataFromApi(url) {
//   const header = {
//     headers: {
//       Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
//     },
//   };
//   const response = await fetch(
//     process.env.REACT_APP_API_ENDPOINT + url,
//     header
//   );

//   if (!response.ok) {
//     handleFetchError(response.status);
//   }
//   return await response.json();
// }

export async function fetchDataFromApi(url) {
  try {
    const response = await fetch(process.env.REACT_APP_API_ENDPOINT + url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("ca1rt6_t")}`,
      },
    });

    // Check if response is unauthorized (401)
    if (response.status === 401) {
      localStorage.clear();
      window.location.href = "/#/Login"; // Redirect to login
      // navigate("/Login");
      return null; // Stop further execution
    }

    if (!response.ok) {
      // Toast(false,"","Sonething went wrong.")
      throw new Error(`HTTP Error: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Fetch error:", error);
    Toast(false, "", error);
    return null; // Return null on failure
  }
}

const handleFetchError = (errorMessage) => {
  console.error("ERROR", errorMessage);
  // Handle or display the error as needed
};

// For custom styling on dropdown arrow of react slelect
export const customStyles = {
  dropdownIndicator: (base, state) => ({
    ...base,
    transition: "transform 0.25s ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
  }),
};

export function wpotpapi() {
  var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("authkey", "421315ADYwJxOmuU663daadeP1");

  var raw = JSON.stringify({
    integrated_number: "919227030193",
    content_type: "template",
    payload: {
      messaging_product: "whatsapp",
      type: "template",
      template: {
        name: "send_code",
        language: {
          code: "en",
          policy: "deterministic",
        },
        namespace: null,
        to_and_components: [
          {
            to: ["7069905525"],
            components: {
              body_1: {
                type: "text",
                value: "Eden's Motor",
              },
              body_2: {
                type: "text",
                value: "1234",
              },
            },
          },
        ],
      },
    },
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  fetch(
    "https://api.msg91.com/api/v5/whatsapp/whatsapp-outbound-message/bulk/",
    requestOptions
  )
    .then((response) => response.text())
    .then((result) => console.log(result))
    .catch((error) => console.log("error", error));
}

export function posttocarthipage(data) {
  const raw = JSON.stringify({
    message: `${data?.modelyear} ${data?.companyid} ${data?.carmodelid}${
      data?.variantid
    }
  👉Get more details by clicking on this below link🔗
     http://m.carthi.in/#/CatDetails/${data.Rand}/${localStorage.getItem(
      "Ca1itd"
    )}/W_hB`,
    channel: "instagram",
    channelid: 17841469669087996,
    photo: data.carphoto,
    trackableLinks: true,
  });

  var requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },

    body: raw,
  };

  fetch(
    "https://api.vbout.com/1/socialmedia/addpost.json?key=2572483423306831136470432",
    requestOptions
  )
    .then((response) => response.json())
    .then((result) => console.log(result))
    .catch((error) => console.log("error", error));
}
export function getOrdinal(num) {
  // this is used in old pages like info.jsx but not in new pages
  const suffixes = ["th", "st", "nd", "rd"];
  const remainder = num % 100;
  return (
    num +
    (suffixes[(remainder - 20) % 10] || suffixes[remainder] || suffixes[0])
  );
}
export const formateNumberStNdRd = (num) => {
  const isNotNumber = isNaN(num) || num === null || num === undefined;
  if (isNotNumber) return num;
  const lastDigit = num % 10;
  const lastTwoDigit = num % 100;

  if (lastTwoDigit >= 11 && lastTwoDigit <= 13) {
    return num + "th";
  }

  switch (lastDigit) {
    case 1:
      return num + "st";
    case 2:
      return num + "nd";
    case 3:
      return num + "rd";
    default:
      return num + "th";
  }
};

export const generatestocklist = async (dataArray) => {
  // Create a new PDF document
  const pdf = new jsPDF();
  const url = await urltobase64(
    "https://apps.carthi.in/Admin/assets/images/app_logo.png"
  );

  // Define the columns for the table
  const columns = [
    "No",
    "Vehicle",
    "varient",
    "Year",
    "Fuel",
    "Transmission",
    "Owner",
    "Km",
    "Price",
  ];

  const title = localStorage.getItem("Ca1nioamed");
  const subtitle = "Stock List";
  // Define the rows for the table
  const rows = dataArray.map((item, index) => [
    index + 1,
    item.carmodelid,
    item.variantid,
    item.modelyear,
    item.fueltypeid,
    item.gear,
    getOrdinal(item.owner),
    item.km,
    item.nSaleprice,
  ]);
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();
  pdf.setFontSize(12);

  pdf.text(title, pdfWidth / 2, 12, { align: "center" });
  pdf.text(subtitle, pdfWidth / 2, 20, { align: "center" });

  pdf.autoTable({
    head: [columns],
    body: rows,
    theme: "striped",
    margin: { top: 25, bottom: 30 },

    styles: {
      halign: "center", // Horizontal alignment for text
    },

    headStyles: {
      fillColor: [237, 28, 36],
      textColor: [255, 255, 255],
      fontStyle: "bold",
    },
    didDrawPage: (data) => {
      // Footer content for every page
      const footerText = `Report Created By:`;

      // Set footer-specific styles
      pdf.setFontSize(8);
      pdf.setTextColor("#949191");

      pdf.text(footerText, pdfWidth / 2, pdfHeight - 20, { align: "center" });

      // Add image to the footer (center-aligned)
      const imgWidth = 31; // Adjust image width
      const imgHeight = 14; // Adjust image height
      const imgX = (pdfWidth - imgWidth) / 2; // Calculate X to center the image
      const imgY = pdfHeight - 18;

      pdf.addImage(url, "PNG", imgX, imgY, imgWidth, imgHeight);
    },
  });
  let filename = "Mystocklist" + new Date().toJSON().slice(0, 13) + ".pdf";
  if (iphone) {
    let bs64 = await pdf.output("datauristring");
    passBs64ChunkReactNative({
      base64: bs64,
      filename,
    });
    return;
  }
  pdf.save(filename);
};
export const generateownerist = async (dataArray) => {
  // Create a new PDF document
  const pdf = new jsPDF();
  const url = await urltobase64(
    "https://apps.carthi.in/Admin/assets/images/app_logo.png"
  );

  // Define the columns for the table
  const columns = ["No", "Car Number", "Model", "Buyer", "Seller"];
  const title = localStorage.getItem("Ca1nioamed");
  const subtitle = "Buyer/Seller Report";
  // Define the rows for the table
  const rows = dataArray.map((item, index) => [
    index + 1,
    item.Carno,
    item.carmodelname,
    item.nDetails.split("|")[0],
    item.nDetails.split("|")[1],
  ]);
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();
  pdf.setFontSize(12);

  pdf.text(title, pdfWidth / 2, 12, { align: "center" });
  pdf.text(subtitle, pdfWidth / 2, 20, { align: "center" });

  pdf.autoTable({
    head: [columns],
    body: rows,
    theme: "striped",
    margin: { top: 25, bottom: 30 },

    styles: {
      halign: "center", // Horizontal alignment for text
    },

    headStyles: {
      fillColor: [237, 28, 36],
      textColor: [255, 255, 255],
      fontStyle: "bold",
    },
    didDrawPage: (data) => {
      // Footer content for every page
      const footerText = `Report Created By:`;

      // Set footer-specific styles
      pdf.setFontSize(8);
      pdf.setTextColor("#949191");

      pdf.text(footerText, pdfWidth / 2, pdfHeight - 20, { align: "center" });

      // Add image to the footer (center-aligned)
      const imgWidth = 31; // Adjust image width
      const imgHeight = 14; // Adjust image height
      const imgX = (pdfWidth - imgWidth) / 2; // Calculate X to center the image
      const imgY = pdfHeight - 18;

      pdf.addImage(url, "PNG", imgX, imgY, imgWidth, imgHeight);
    },
  });
  let filename = "Buyersellerlist" + new Date().toJSON().slice(0, 13) + ".pdf";
  if (iphone) {
    let bs64 = pdf.output("datauristring");
    passBs64ChunkReactNative({ base64: bs64, filename });
    return;
  }
  pdf.save(filename);
};

export async function PushpoptoCatalogue(carnumber, carid, Request) {
  // add or remove car in catalogue
  let res = {};
  const header = {
    method: "POST",
    mode: "cors",
    headers: {
      Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
  };
  await fetch(
    process.env.REACT_APP_API_ENDPOINT +
      "/api/Carmaster/addUpdatecateloge?carnumber=" +
      carnumber +
      "&carid=" +
      carid +
      "&carstatus=" +
      Request,
    header
  )
    .then((response) => response.json())
    .then((response) => {
      res = response;
    });
  return res;
}

const PasswordCustomUiJsx = ({ onClose, onSubmit, message }) => {
  // because in customaUi it is static jsx so first renders ui is last ui and not dynamic change like show or off password
  const [showPassword, setShowPassword] = useState(false);
  const [value, setValue] = useState("");
  console.log("showPassword", showPassword);

  return (
    <div className="popup-overlay px-3 py-3 text-center">
      {/* <p>Are you sure you want to delete this car record?</p> */}
      <label className="text-danger" style={{ fontWeight: "500" }}>
        {message}
      </label>
      <div className="form-div" style={{ position: "relative" }}>
        <label className="form-label">Password</label>
        <input
          type={showPassword ? "text" : "password"}
          className="form-control"
          name="password"
          onChange={(e) => {
            setValue(e.target.value);
          }}
        />

        <span
          className="material-symbols-outlined eyespan"
          id="passwordicon"
          onClick={() => {
            setShowPassword(!showPassword);
            console.log("showPassword", showPassword);
          }}
        >
          {showPassword ? "visibility_off" : "visibility"}
        </span>
      </div>
      <button
        className="submitbtn me-2 popup-btn"
        onClick={() => {
          checkpassword(onSubmit, value, onClose);
          onClose();
        }}
      >
        Submit
      </button>
      <button
        className="submitbtn me-2 popup-btn"
        onClick={() => {
          onClose();
        }}
      >
        Close
      </button>
    </div>
  );
};

export const PasswordPopup = ({
  method,
  message = "To delete this record, we require your account password.",
}) => {
  confirmAlert({
    customUI: ({ onClose }) => (
      <PasswordCustomUiJsx
        onClose={onClose}
        onSubmit={method}
        message={message}
      />
    ),
  });
};

export const checkpassword = (method, value, closemethod) => {
  const header = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("ca1rt6_t"),
    },
  };

  fetch(
    process.env.REACT_APP_API_ENDPOINT +
      "/api/BuyerSeller/PasswordVerifyforEditBuyerSeller?password=" +
      encodeURIComponent(value),
    header
  )
    .then((response) => response.json())
    .then((res) => {
      if (res.Success) {
        closemethod();
        method();
      } else {
        closemethod();
        Toast(res.Success, "", res.Message);
      }
    });
};
// BY RAJESH
export const validatorGF = ({ Case, val, isvalid, require = true }) => {
  //Case: match case
  //require: is require or not
  const obj = {
    returnErr: "", //
    returnValid: isvalid,
  }; // return obj
  let pattern;
  let trimVal = String(val).trim();
  switch (Case) {
    case "require":
      if (!trimVal && trimVal !== 0) {
        // empty value not allowed
        obj.returnValid = false;
        obj.returnErr = "Can't be empty";
      }
      break;

    case "mobile":
      if (require && !trimVal && trimVal !== 0) {
        obj.returnValid = false;
        obj.returnErr = "Can't be empty";
      } else {
        // only number start with 6 to 9 with 10 digits
        pattern = new RegExp(/^[6-9]\d{9}$/);
        if (!pattern.test(trimVal)) {
          obj.returnValid = false;
          obj.returnErr = "Enter valid mobile number.";
        }
      }
      break;

    case "onlyChar":
      if (require && !trimVal && trimVal !== 0) {
        obj.returnValid = false;
        obj.returnErr = "Can't be empty";
      } else {
        pattern = new RegExp(/^[a-zA-Z ]*$/);
        //only charators allowed
        if (!pattern.test(trimVal)) {
          obj.returnValid = false;
          obj.returnErr["name"] = "Please enter only characters.";
        }
      }
      break;
    case "email": // email validation as require field
      if (trimVal.length === 0 && require) {
        obj.returnValid = false;
        obj.returnErr = "Can't be empty";
      } else if (trimVal.length !== 0) {
        pattern =
          /^(?!.*[._%+-]{2})[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!pattern.test(trimVal)) {
          obj.returnErr = "Invalid email address";
          obj.returnValid = false;
        }
      }
    // no default
  }

  return obj;
};

export const handleGetApiGF = async ({
  url,
  checksucc = true, // will check success status
  contentType = "application/x-www-form-urlencoded",
}) => {
  const uid = localStorage.getItem("ca1rt6_t");
  const apiheader = {
    headers: {
      "Content-Type": contentType,
      Authorization: "Bearer " + uid,
    },
  };
  try {
    const res = await axios.get(
      process.env.REACT_APP_API_ENDPOINT + url,
      apiheader
    );
    console.log("res cm", res);

    return {
      succ: res.data.Success,
      data: res?.data,
      msg: res.data?.Message,
    };
  } catch (err) {
    console.error("error from catch get api", err);
    let err_msg =
      err?.response?.data?.Message || err.message || "Something went wrong";
    // Toast(false, "", err_msg);
    if (
      err?.status === 401 ||
      err_msg === "Authorization has been denied for this request."
    ) {
      setTimeout(() => {
        localStorage.clear();
        // window.location.href = "/#/Login"; // Redirect to login
      }, 1500);
    }
    return {
      succ: false,
      msg: err_msg || "Something went wrong",
    };
  }
};

export const handlePostApiGF = async ({
  url,
  obj,
  checksucc = true, // will check success status
  contentType = "application/x-www-form-urlencoded",
}) => {
  // default value
  let encoded = "";

  if (obj) {
    encoded =
      contentType === "application/json"
        ? obj
        : new URLSearchParams(obj).toString();
  }

  const uid = localStorage.getItem("ca1rt6_t");

  const apiheader = {
    headers: {
      "Content-Type": contentType,
      Authorization: "Bearer " + uid,
    },
  };
  try {
    const res = await axios.post(
      process.env.REACT_APP_API_ENDPOINT + url,
      encoded,
      apiheader
    );

    return {
      data: res?.data,
      succ: res?.data?.Success,
      msg: res?.data?.Message,
    };
  } catch (err) {
    console.error("catch post api error", err);
    let err_msg =
      err?.response?.data?.Message || err.message || "Something went wrong";

    // unAuthorization
    if (err?.status === 401) {
      localStorage.clear();
      window.location.href = "/#/Login"; // Redirect to login
      // Stop further execution
    }
    return { succ: false, msg: err_msg || "Something went wrong" };
  }
};

const passBs64ChunkReactNative = ({ base64 = "", filename = "" }) => {
  if (!base64) return;
  const chunk_size = 1024 * 1024; // 1MB per chunk
  for (let i = 0; i < base64.length; i += chunk_size) {
    shareIphonePostMsg({
      data: base64.substring(i, i + chunk_size),
      action: "chunk",
      filename,
      nextChunk: i + chunk_size < base64.length, // chunk size is less than bs64 lenth mean next chunk have to pass
    });
  }
};
// fire boolan animation js
export const fireAnimation = () => {
  /* eslint-disable no-undef */
  const count = 300,
    defaults = {
      origin: { y: 0.7 },
    };

  const colors = ["#bb0000", "#ffffff", "#f3d573"];

  function fire(particleRatio, opts) {
    confetti(
      Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio) + 50,
        angle: 60,
        spread: 55,
        origin: { x: 0, y: 1 },
        colors: colors,
        startVelocity: 90,
        gravity: 0.5,
      })
    );
    confetti(
      Object.assign({}, defaults, opts, {
        particleCount: Math.floor(count * particleRatio) + 50,
        angle: 120,
        spread: 55,
        origin: { x: 1, y: 1 },
        colors: colors,
        startVelocity: 90,
        gravity: 0.5,
      })
    );
  }

  fire(0.25, {
    spread: 26,
    startVelocity: 55,
  });

  fire(0.2, {
    spread: 60,
  });

  fire(0.35, {
    spread: 100,
    decay: 0.91,
    scalar: 0.8,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 25,
    decay: 0.92,
    scalar: 1.2,
  });

  fire(0.1, {
    spread: 120,
    startVelocity: 45,
  });
};

// FETCH BLOB FROM URL
export const fetchBlobFromUrl = async ({ url }) => {
  try {
    const response = await axios.get(url, {
      responseType: "blob", // IMPORTANT: ensures it's treated as binary
    });
    return response.data;
  } catch (error) {
    console.error("blob fetch failed:", error);
    Toast(false, "", "Error: blob fetch failed");
    return null;
  }
};

export function formatRupee({ amt, decimal = 0, rupeeIcon = true }) {
  try {
    // Convert to number safely
    const num = Number(amt);

    // Check if it's a valid number
    if (isNaN(num)) {
      throw new Error("Invalid amount");
    }
    if (rupeeIcon) {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: decimal,
      }).format(num);
    } else {
      return new Intl.NumberFormat("en-IN", {
        maximumFractionDigits: decimal,
      }).format(num);
    }
  } catch (err) {
    console.error("Rupee formatting error:", err.message);
    return "₹0.00"; // fallback
  }
}

export const getMillisecond = (date) =>
  (date && new Date(date)?.getTime()) || Math.random();
// ✅ utility to save clicked item id
export const handlerSetScrollId = ({ e, key }) => {
  try {
    if (!e) return;
    // find closest element that has the scroll id attribute
    let item = e.target.closest("[data-scroll-id]");
    if (!item) return;

    let id = item.getAttribute("data-scroll-id");
    if (!id) return;

    sessionStorage.setItem(`scroll-${key}`, id);
    console.log("Saved scroll ID:", id);
  } catch (error) {
    console.error("set scroll id error", error);
  }
};

// ✅ utility to restore scroll to saved id
export const handlerScrollToId = ({ key, parentRef }) => {
  try {
    let id = sessionStorage.getItem(`scroll-${key}`);
    console.log("id", id);

    if (!id || !parentRef?.current) return;

    let item = document.querySelector(`[data-scroll-id='${id}']`);
    console.log("Restoring scroll to ID:", item);

    if (!item) return;

    item.scrollIntoView({ behavior: "smooth", block: "center" });
    console.log("Restored scroll to:", id);
  } catch (error) {
    console.error("scroll to id error", error);
  }
};

export const sendMsgWhatsapp = ({ mobile, text }) => {
  const txt = encodeURIComponent(text);
  // const iphone = window.navigator.userAgent.includes("Mac");

  const ua = navigator.userAgent || navigator.vendor || window.opera;
  // Detect platform
  const isAndroid = /android/i.test(ua);
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  let mobileno = mobile
    ? String(mobile).startsWith("91") && String(mobile).trim().length >= 12
      ? mobile
      : `91${mobile}`
    : "919712947379";
  console.log("mb", mobileno);

  // WhatsApp URLs
  const waWeb = `https://wa.me/${mobileno}?text=${txt}`;
  const waPersonal = `intent://send?phone=+${mobileno}&text=${txt}#Intent;scheme=whatsapp;package=com.whatsapp;end`;
  const waBusiness = `intent://send?phone=+${mobileno}&text=${txt}#Intent;scheme=whatsapp;package=com.whatsapp.w4b;end`;

  if (isAndroid) {
    // Try Business first, fallback to Personal
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = waBusiness;
    document.body.appendChild(iframe);
    setTimeout(() => {
      // fallback to personal whatsapp
      document.body.removeChild(iframe);
      const iframe2 = document.createElement("iframe");
      iframe2.style.display = "none";
      iframe2.src = waPersonal;
      document.body.appendChild(iframe2);
      setTimeout(() => document.body.removeChild(iframe2), 1000);
    }, 800);
  } else if (isIOS) {
    // iPhone/iPad → open via whatsapp:// or universal link
    const url = `whatsapp://send?phone=${mobileno}&text=${txt}`;
    shareIphonePostMsg({ url, action: "open_url_linking" });
  } else {
    // Desktop (Mac/Windows/Linux)
    window.open(waWeb, "_blank");
  }
};

export const priceTagCmn = [
  { Value: "Fixed Price", Text: "Fixed Price" },
  { Value: "Negotiable", Text: "Negotiable" },
];

export const isIOS = () => {
  const ua = navigator.userAgent;
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)
  );
};

export const demoDeviceToken = async () => {
  try {
    const token = localStorage.getItem("ca1rt6_t");
    if (!token) {
      console.log("JWT not found in localStorage");
      return;
    }
    let params = new URLSearchParams({
      nDevicetype: "ios",
      nDeviceid: "ExponentPushToken[Ws1eq2N6paG5I1iu4mGFGH]",
    }).toString();

    const response = await fetch(
      "https://api.carthi.in/api/AddDivicelog/AddDevicelogdetails?" + params,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + token,
        },
      }
    );

    const result = await response.json();
  } catch (err) {
    console.log(err?.message);
  }
};
